import { Typography } from '@mui/material';
import React from 'react';
import { headingNotSet } from '../../services/TemplateUtils';
import FootnoteRenderer from '../FootnoteRenderer';
import StyledSection from '../styles/StyledSection';
import { StyledHeading } from '../styles/styles';
import TableCellView from './TableCellView';
import type { TableProps, TableRow } from './tableTypes';
import './Table.scss';

export type {
  TableCell,
  TableCellStyle,
  TableContent,
  TableMobileCard,
  TableMobileField,
  TableMobileSection,
  TableMobileView,
  TableProps,
  TableRow,
} from './tableTypes';

export default function Table({
  id,
  rows,
  heading,
  tone = 'tone1',
  footnotes,
  firstElement,
}: TableProps) {
  if (!rows?.length) {
    return (
      <StyledSection noSidePaddingFrom="xs" tone={tone}>
        <Typography variant="body2" sx={{ color: 'error.main' }}>
          This section is missing required content and could not be rendered.
        </Typography>
      </StyledSection>
    );
  }
  const [headerRow, ...bodyRows] = rows;
  const renderRowCells = (row: TableRow, isHeaderRow = false) =>
    row.cells.map((cell, cellIndex) => (
      <TableCellView
        key={cell.id}
        cell={cell}
        isHeaderRow={isHeaderRow}
        isFirstColumn={cellIndex === 0}
      />
    ));
  return (
    <StyledSection
      id={id}
      tone={tone}
      additionalClassName="table-sectioncontent-management-item"
      noSidePaddingFrom="xs"
      noTopPadding={!firstElement}
    >
      {!headingNotSet(heading) && (
        <StyledHeading tone={tone} headerVariant="heading2">
          {heading.content}
        </StyledHeading>
      )}
      <div className="table-container">
        <table>
          <thead>
            <tr>{renderRowCells(headerRow, true)}</tr>
          </thead>
          <tbody>
            {bodyRows.map((row, index) => (
              <tr key={index}>{renderRowCells(row)}</tr>
            ))}
          </tbody>
        </table>
      </div>
      <FootnoteRenderer footnotes={footnotes} tone={tone} />
    </StyledSection>
  );
}
